import { useMutation } from '@tanstack/react-query';
import { automationsRepo } from '@/constants/providers';
import { ApiResponse } from '@/shared/types';

export const useDisableAutomation = () =>
  useMutation<ApiResponse<unknown>, unknown, number>((id) =>
    automationsRepo.disableAutomation(id),
  );
